import { Button, Text } from '#atoms';
import { PATH } from '#const/path';
import { LabelWithButton, Modal } from '#molecules';
import CoachMark from '#shared/CoachMark';
import { RegisteredCoachScheduleDetail } from '#types/schedule';
import dayjs from 'dayjs';
import { CSSProperties, useState } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { ModalButtonContainer } from 'src/components/pages/WeeklyCalenderDetail/styles';
import { useRepetitionText } from '../hooks';

interface RepititionProps {
  isGroup: boolean;
  schedule: RegisteredCoachScheduleDetail | undefined;
}
export const Repitition = ({ schedule, isGroup }: RepititionProps) => {
  const [searchParams] = useSearchParams();
  const lectureScheduleId = decodeURIComponent(
    searchParams.get('lecture-schedule-id') ?? ''
  );

  // 오늘 0시 수업부터  반복 수정 가능
  const todayMidnight = dayjs().startOf('day'); // Today's 00:00
  const isPastSchedule = dayjs(schedule?.taughtAt).isBefore(todayMidnight);

  const repetitionText = useRepetitionText();

  const navigate = useNavigate();

  const modalCondition = !isGroup && isPastSchedule;

  // 반복을 수정할 수 없는 경우 모달을 띄움
  const [isOepnModal, setIsOpenModal] = useState(false);

  const textStyles: CSSProperties = {
    width: '80%',
    wordBreak: 'keep-all',
    textAlign: 'center'
  };

  return (
    <>
      {!isGroup && (
        <CoachMark.SpotLight style={{ padding: '12px', borderRadius: '12px' }}>
          <CoachMark.Tooltip
            position="top"
            message={`반복 설정을 통해 반복되는 일정을 \n 한 번에 등록할 수 있어요`}
          />
          <LabelWithButton
            style={{
              backgroundColor: 'var(--color-gray)',
              color: 'var(--color-gray-text)'
            }}
            label={'반복'}
            defaultButtonText={repetitionText}
            onClick={() => {
              if (modalCondition) {
                setIsOpenModal(true);
                return;
              }

              navigate(
                `${PATH.WEEKLY_CALENDER_REPEAT}?lecture-schedule-id=${lectureScheduleId}`
              );
            }}
          />
        </CoachMark.SpotLight>
      )}

      {isOepnModal && (
        <Modal onClose={() => setIsOpenModal(false)}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              justifyContent: 'center',
              alignItems: 'center',
              marginBottom: '24px'
            }}
          >
            <Text style={textStyles}>
              과거 일정은 반복을 수정할 수 없습니다.
            </Text>
          </div>

          <ModalButtonContainer>
            <Button onClick={() => setIsOpenModal(false)}>확인</Button>
          </ModalButtonContainer>
        </Modal>
      )}
    </>
  );
};
